export default __webpack_public_path__ + "static/Muli-RegularItalic-f909a15c03ef600eb35f28f6e9523560.ttf";